import React, { FC } from 'react';

import { Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';

import { IAdminOwnershipDetailsData } from '@pharmaplan/common';

import { currencyFormatter } from '../../../../helpers/Functions';
import strings from '../../../../localization';

import styles from './styles';

export type IAllowancesBreakdown = Pick<
IAdminOwnershipDetailsData,
| 'accommodationAllowance'
| 'travelAllowance'
| 'mealAllowance'
| 'emergencyFees'
| 'otherAllowance'
| 'totalAllowance'
>;

const Row = ({ label, value }: { label: string; value: string }) =>
  (
    <Grid container xs={12} sx={styles.breakdownRow}>
      <Grid item xs={6}>
        <Typography sx={styles.breakdownLabel}>
          {label}
          :
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography sx={styles.breakdownValue}>{value}</Typography>
      </Grid>
    </Grid>
  );

const AllowancesBreakdown: FC<IAllowancesBreakdown> = ({
  accommodationAllowance,
  travelAllowance,
  mealAllowance,
  emergencyFees,
  otherAllowance,
  totalAllowance,
}) =>
  (
    <Box sx={styles.breakdownContainer}>
      <Row
        label={strings.accomodation}
        value={currencyFormatter(accommodationAllowance)}
      />
      <Row label={strings.travel} value={currencyFormatter(travelAllowance)} />
      <Row label={strings.meal} value={currencyFormatter(mealAllowance)} />
      <Row
        label={strings.emergencyServiceFees}
        value={currencyFormatter(emergencyFees)}
      />
      <Row label={strings.other} value={currencyFormatter(otherAllowance)} />
      <Row
        label={strings.total}
        value={currencyFormatter(totalAllowance)}
      />
    </Box>
  );

export default AllowancesBreakdown;
